<template>
    <div class="bg">
        <div class="container" v-if="!loadEnd">
            <div class="text">
                {{'三维看板加载中... (' + widthLoad + '%)'}}
                <Loading :width="widthLoad"></Loading>
            </div>
            <div class="exit" @click="$router.go(-1)">退出三维看板</div>
        </div>
        <iframe class='iframe' name="3D" frameborder="0" width="100%" height="100%" ref="iframeDom" :src="url"></iframe>
    </div>
</template>

<script>
    import Loading from './Loading'
    import {
        GetProJectInfo,
    } from "@/api/common"
    export default {
        name: "ThreeD",
        components: {
            Loading,
        },
        data() {
            return {
                url: '',
                loadEnd: false,
                width: 0,
                timer: null,
            }
        },
        computed:{
            widthLoad(){
                let width = this.width < 100 ? this.width : 100
                return width
            }
        },
        watch:{
            widthLoad(width){
                let that = this
                if(width == 100){
                    this.timer = setTimeout(()=>{
                            that.loadEnd = true
                            that.iframeWin.postMessage({
                                cmd: "3Dstart",
                            },"*");
                        },1000)
                }
            }
        },
        mounted() {
            GetProJectInfo().then(res => {
                this.url = res.data.data.project.webUrl
            }),
            this.iframeWin = this.$refs.iframeDom.contentWindow;
            window.addEventListener("message", this.handleMessage);
        },
        beforeDestroy() {
            window.removeEventListener("message", this.handleMessage);
            this.timer && clearTimeout(this.timer)
            this.timer && (this.timer = null)
        },
        methods: {
            handleMessage(event) {
                const data = event.data;
                console.log(data,'data')
                switch (data.cmd) {
                    case "exit":
                        this.$router.push('/SubstationManagement')
                        break
                    case "loadEnd":
                        this.width = 100
                        this.timer = setTimeout(()=>{
                            this.loadEnd = true
                        },1000)
                        break
                    case "loadProgress":
                        this.width = data.value * 4
                        break
                }
            }
        }
    }
</script>

<style lang='less' scoped>
    .bg {
        width: 100vw;
        height: 100vh;
        background: #000;
        position: fixed;
        top: 0;
        left: 0;
    }

    .container {
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        background-image: url('../../assets/img/3D背景.png');
        background-size: 100% 100%;
        color: white;

        .text {
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            z-index: -1;
            font-size: 50rem;
            width: 40vw;
            height: 20vh;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
        }

        .exit {
            position: fixed;
            right: 80px;
            top: 50px;
            font-size: 30rem;
            cursor: pointer;
        }
    }
</style>